export const COMMON_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
];

export const SEARCH_PATTERNS = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  linkedin: /linkedin\.com\/in\/[\w-]+/i,
  linkedinFlexible: /linkedin\.com\/in\/[\w-]{3,}/i,
  linkedinDomainLike: /^(https?:\/\/)?(www\.)?linkedin\.com(\/)?$/i,
  linkedinPathLike: /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|pub|profile\/view)\//i,
  name: /^[\p{L}\s'-]+$/u,
};

export const LINKEDIN_DETECTION_PATTERNS = [
  "linkedin.com/in/",
  "linkedin.com/pub/",
  "linkedin.com/profile/view/",
];

export const SEARCH_CONFIG = {
  hitsPerPage: 20,
  minWordSizefor1Typo: 4,
  minWordSizefor2Typos: 8,
  minCompanyNameLength: 2,
  minWordLength: 2,
  minNameWords: 2,
};

export const VALIDATION_MESSAGES = {
  name: "Names can only contain letters, spaces, apostrophes, and hyphens",
  email: "Please enter a valid email address",
  linkedin: "Please enter a valid public profile URL",
  discover: "Describe a role or expertise to find matching professionals",
  required: "This field is required",
};

export const USER_ATTRIBUTES = [
  "objectID",
  "id",
  "sub",
  "vanity",
  "profile.given_name",
  "profile.family_name",
  "profile.picture",
  "profile.picture_custom",
  "profile.picture_cached",
  "profile.expertise",
  "profile.country_code",
  "location",
  "location.city",
  "location.country",
  "profile.is_public",
  "profile.url",
  "company.name",
  "company.url",
  "contacts.email",
  "profile.linkedin_url",

  "profile.accept_percent",
  "profile.response_rate",
  "stats.meeting_stats.received.requested",
  "stats.meeting_stats.received.dismissed",
  "stats.meeting_stats.received.completed",
  "stats.meeting_stats.sent.completed",

  "profile.hourly_rate",
  "profile.half_rate",

  "profile.sessionTypes",
  "profile.rateSettings",
  "profile.meetingTypes",

  "profile.intro",
  "profile.about",
  "profile.affiliation_name",
  "profile.affiliation_url",
  "profile.title",

  // LinkedIn quality signals
  "linkedin.premium",
  "linkedin.verified",
  "linkedin.follower",
  "linkedin.title",
  "linkedin.headline",
];

export const LINKEDIN_ATTRIBUTES = [
  ...USER_ATTRIBUTES.filter((attr) => attr !== "contacts.email"),
  "profile.linkedin_url",
  "linkedin.vanity",
];

export const PORTFOLIO_ATTRIBUTES = [
  "objectID",
  "id",
  "vanity",
  "profile.given_name",
  "profile.family_name",
  "profile.picture",
  "profile.picture_custom",
  "profile.picture_cached",
  "profile.expertise",
  "profile.country_code",
  "location",
  "location.city",
  "location.country",
  "profile.is_public",
  "profile.affiliation_name",
  "profile.affiliation_url",
  "company.name",
  "company.url",
  "contacts.email",
  "profile.linkedin_url",
  "profile.accept_percent",

  "profile.hourly_rate",
  "profile.half_rate",

  "profile.sessionTypes",
  "profile.rateSettings",
  "profile.meetingTypes",
  "profile.title",
  "profile.intro",
  "profile.about",

  // Quality signals for discover ranking
  "linkedin.premium",
  "linkedin.verified",
  "linkedin.follower",
  "linkedin.title",
  "linkedin.headline",
];
